import { defineMessages } from 'react-intl'

export default defineMessages({
  cancel: {
    defaultMessage: 'Cancel editing reference',
    description: 'Smart Shares table active tab | cancel reference edit button label',
  },
  edit: {
    defaultMessage: 'Edit reference',
    description: 'Smart Shares table active tab | edit reference button label',
  },
  inputLabel: {
    defaultMessage: 'Share reference',
    description: 'Smart Shares table active tab | reference input accessible label',
  },
  maxLengthValidation: {
    defaultMessage: 'Reference cannot be longer than 60 characters',
    description: 'Smart Shares table active tab | reference max length validation message',
  },
  placeholder: {
    defaultMessage: 'Add a reference',
    description: 'Smart Shares table active tab | reference input placeholder',
  },
  save: {
    defaultMessage: 'Save reference',
    description: 'Smart Shares table active tab | save reference button label',
  },
  updateError: {
    defaultMessage: 'Could not update the share reference. Please try again.',
    description: 'Smart Shares table active tab | reference update failure toast',
  },
  updateSuccess: {
    defaultMessage: 'Share reference updated',
    description: 'Smart Shares table active tab | reference update success toast',
  },
})
